const initialState = {
  isFetching: false,
  isFetched: false,
  success: false,
  error: false,
  data: null
}

export const ACTION_TYPES = {
  FEATURE_TOGGLE_REQUEST: 'FEATURE_TOGGLE_REQUEST',
  FEATURE_TOGGLE_SUCCESS: 'FEATURE_TOGGLE_SUCCESS',
  FEATURE_TOGGLE_ERROR: 'FEATURE_TOGGLE_ERROR'
}


export const getFeatureToggle = () => ({
  type: ACTION_TYPES.FEATURE_TOGGLE_REQUEST
})

const featureToggle = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.FEATURE_TOGGLE_REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case ACTION_TYPES.FEATURE_TOGGLE_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        success: true,
        data: payload.data.features
      }
    case ACTION_TYPES.FEATURE_TOGGLE_ERROR:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        error: true
      }
    default:
      return state
  }
}

export default featureToggle
